import React, { useState } from "react";
import DOMPurify from "dompurify";

const FAQ = ({ faqs }) => {
  const faqData = faqs || [
    {
      question: "Do you offer revisions on website design projects?",
      answer:
        "Yes, all our design packages include at least one revision cycle. The number of revisions depends on the service tier you choose.",
    },
    {
      question: "Can you build websites on platforms like WordPress, Shopify, or Squarespace?",
      answer:
        "Absolutely. We specialize in WordPress, Shopify, Squarespace, and also offer custom-coded solutions.",
    },
    {
      question: "How long does it take to develop a mobile app?",
      answer:
        "Basic apps take 2–5 weeks, while full-featured or cross-platform apps may take 4–12 weeks or more.",
    },
    {
      question: "What is included in the Full Website Creation service?",
      answer:
        "Design, development, CMS setup, responsive layout, SEO basics, hosting/domain setup, and deployment support.",
    },
    {
      question: "Do you create custom APIs for mobile apps?",
      answer:
        "Yes, we offer API creation services tailored for your app needs — secure, scalable, and documented.",
    },
    {
      question: "Will my site be SEO-friendly?",
      answer:
        "Yes, all websites are built with SEO best practices including clean code, meta tags, and image optimization.",
    },
    {
      question: "Do you provide logo and branding design?",
      answer:
        "Yes, including logo design, brand guidelines, typography, and color palette with all file formats.",
    },
    {
      question: "What tools do you use for graphic design projects?",
      answer:
        "Adobe Creative Suite (Photoshop, Illustrator, XD) and Figma for UI/UX design and mockups.",
    },
    {
      question: "Do you run social media or email campaigns?",
      answer:
        "Yes — email marketing, automation, and content for Instagram, Facebook, and LinkedIn.",
    },
    {
      question: "What payment methods do you accept?",
      answer:
        "PayPal, wire transfer, Remitly, Western Union, and others depending on your location.",
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);
  const [showAll, setShowAll] = useState(false);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const displayedFaqs = showAll ? faqData : faqData.slice(0, 5);

  return (
    <div className="mx-auto w-full max-w-7xl px-4 py-10 flex flex-col md:flex-row">
      {/* Left Section: FAQ */}
      <div className="flex-1 md:w-2/3 space-y-4">
        <h2 className="text-2xl font-bold text-left text-gray-900 mb-4 pb-2">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4">
          {displayedFaqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white shadow-lg rounded-lg overflow-hidden border border-gray-200"
            >
              <div
                className="flex justify-between items-center p-4 cursor-pointer"
                onClick={() => toggleFAQ(index)}
              >
                <h3 className="text-[14px] lg:text-lg font-semibold text-gray-800">
                  {faq.question}
                </h3>
                <span
                  className={`transform transition-all ${
                    openIndex === index ? "rotate-180" : "rotate-0"
                  }`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                    className="w-6 h-6 text-gray-600"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </span>
              </div>

              {/* Collapsible Content */}
              <div
                className={`bg-gray-50 text-[12px] lg:text-lg text-gray-700 transition-all duration-300 ease-in-out ${
                  openIndex === index
                    ? "max-h-screen opacity-100 p-4"
                    : "max-h-0 opacity-0 overflow-hidden"
                }`}
              >
                 <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(faq.answer),
                }}
                className="text-gray-900 text-[12px] leading-6"
              />
              </div>
            </div>
          ))}
        </div>

        {/* Show More / Show Less Button */}
        <div className="mt-6">
          <button
            onClick={() => setShowAll(!showAll)}
            className="px-5 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 transition duration-300 shadow-md"
          >
            {showAll ? "Show Less" : "Show More"}
          </button>
        </div>
      </div>

      {/* Right Section: Image */}
      <div className="mt-10 md:mt-0 md:w-1/3 flex justify-center items-center">
        <img
          src="../images/faq.png"
          alt="FAQ Illustration"
          className="w-full max-w-xs rounded-lg"
        />
      </div>
    </div>
  );
};

export default FAQ;
